'use client';
import { useEffect } from 'react';
import { useRawCouponStore } from '../hooks/useCouponStore.js';
/**
 * Consumes the local storage and rehydrates the Zustand coupon store.
 *
 * @returns undefined
 */
export default function LocalStorageConsumer() {
    const couponStore = useRawCouponStore();
    useEffect(() => {
        void couponStore.persist.rehydrate();
    }, [couponStore]);
    return undefined;
}
//# sourceMappingURL=LocalStorageConsumer.js.map